import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenDays'
})
export class ShortenDaysPipe implements PipeTransform {

  transform(value: string[]): unknown {
    // tslint:disable-next-line:triple-equals
    if (JSON.stringify(value) === JSON.stringify(['Mon', 'Tue', 'Wed', 'Thu', ' Fri'])) {
      return 'Weekdays';
    } else if (JSON.stringify(value) === JSON.stringify(['Sat', 'Sun'])) {
      return 'the weekend';
    }
    return value;
  }
}
